import styled from 'styled-components';

import { Box } from '../../primitives';

export const Wrapper = styled(Box)`
	width: 100%;
`;
